import {Record, List} from 'immutable';
import {Observable} from 'rxjs';
import moment from 'moment-timezone';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import * as ClosingDaysApi from 'web-app/api/closing-days-api';

import {type IClosingDay} from './types';

export const fetch = (institutionId: string) =>
    Observable.fromPromise(ClosingDaysApi.fetch(institutionId)).map(response => ({
        closingDays: List(response.closingDays).map(day => closingDayFromApi(day)),
        behaviors: new BehaviorsCollection(response.behaviors),
    }));

export const addClosingDay = (institutionId: string, day: string, reason: string, dayType: number) =>
    Observable.fromPromise(ClosingDaysApi.addClosingDay(institutionId, day, reason, dayType)).map(day =>
        closingDayFromApi(day),
    );

export const deleteClosingDay = (closingDayId: string) =>
    Observable.fromPromise(ClosingDaysApi.deleteClosingDay(closingDayId));

export const deleteClosingDays = (closingDays: List<IClosingDay>) =>
    Observable.fromPromise(
        ClosingDaysApi.deleteClosingDays(closingDays.map(closingDay => closingDay.closingDayId).toArray()),
    );

const closingDayFromApi = (closingDay: any) =>
    new ClosingDay({
        ...closingDay,
        day: moment(closingDay.day, 'YYYY-MM-DD'),
    });

const ClosingDay = Record<IClosingDay>({
    closingDayId: '',
    day: moment(),
    dayType: 0,
    dayTypeTitle: '',
    institutionId: '',
    reason: '',
});
